// @flow
import React, {type Node} from 'react'

type Props = {
  children: Node,
  href: string,
  frame: string,
}

function HotwireLink({href, frame, children}: Props): Node {
  return (
    <a data-turbo-frame={frame} href={href}>{children}</a>
  )
}

export default HotwireLink
